import * as Api from '@ViewModels';

export const availableExternalIntegrationsWithIndustries = [
	{ provider: Api.IntegrationProvider.PracticePanther, industry: Api.Industry.Legal },
	{ provider: Api.IntegrationProvider.MyCase, industry: Api.Industry.Legal },
	{ provider: Api.IntegrationProvider.Eclipse, industry: Api.Industry.Insurance },
	{ provider: Api.IntegrationProvider.Clio, industry: Api.Industry.Legal },
	{ provider: Api.IntegrationProvider.ServiceTitan, industry: Api.Industry.HomeMaintenance },
	{ provider: Api.IntegrationProvider.HousecallPro, industry: Api.Industry.HomeMaintenance },
	{ provider: Api.IntegrationProvider.Wealthbox, industry: Api.Industry.Financial },
	{ provider: Api.IntegrationProvider.Redtail, industry: Api.Industry.Financial },
	{ provider: Api.IntegrationProvider.Bloomerang, industry: Api.Industry.NonProfit },
	{ provider: Api.IntegrationProvider.DonorPerfect, industry: Api.Industry.NonProfit },
	{ provider: Api.IntegrationProvider.CasePeer, industry: Api.Industry.Legal },
	{ provider: Api.IntegrationProvider.MedicarePro, industry: Api.Industry.Insurance },
	{ provider: Api.IntegrationProvider.HawkSoft, industry: Api.Industry.Insurance },
	{ provider: Api.IntegrationProvider.Filevine, industry: Api.Industry.Legal },
];

export const alwaysAvailableExternalIntegrations = [
	{ provider: Api.IntegrationProvider.MicrosoftDynamics365Sales },
	{ provider: Api.IntegrationProvider.Salesforce },
	{ provider: Api.IntegrationProvider.QuickBooksOnline },
];

/** Hidden from admins without OnlyForDevelopers; customers still see them once enabled. */
export const developerOnlyExternalIntegrations: Api.IntegrationProvider[] = [
	Api.IntegrationProvider.MedicarePro,
	Api.IntegrationProvider.Filevine,
];

export const isDeveloperOnlyIntegration = (provider: Api.IntegrationProvider) =>
	developerOnlyExternalIntegrations.includes(provider);

/** Set up only from the admin app, so a customer has no page to manage them on. */
const providersWithoutCustomerPage: Api.IntegrationProvider[] = [Api.IntegrationProvider.HawkSoft];

export const hasCustomerManagePage = (provider: Api.IntegrationProvider) =>
	!providersWithoutCustomerPage.includes(provider);

/** V2 providers whose V1 counterpart lives on `account.integrations` under this key. */
export const v1CounterpartKeys: Partial<Record<Api.IntegrationProvider, keyof Api.IAccountIntegrations>> = {
	[Api.IntegrationProvider.Eclipse]: 'eclipse',
	[Api.IntegrationProvider.HawkSoft]: 'hawkSoft',
};

/** Enabling these runs the V1 migration, so V2 takes over from V1 at enable rather than once it is configured. */
const replacesV1WhenEnabled: Api.IntegrationProvider[] = [Api.IntegrationProvider.HawkSoft];

export const isExternalIntegrationEnabled = (
	integrations: Api.IExternalIntegration[] | undefined,
	provider: Api.IntegrationProvider
) => !!integrations?.find(i => i.provider === provider)?.enabled;

export const isExternalIntegrationLive = (
	integrations: Api.IExternalIntegration[] | undefined,
	provider: Api.IntegrationProvider
) => {
	const integration = integrations?.find(i => i.provider === provider);
	return !!integration?.enabled && !integration.configuration?.needsConfiguration;
};

export const hasV2ReplacedV1 = (
	integrations: Api.IExternalIntegration[] | undefined,
	provider: Api.IntegrationProvider
) =>
	replacesV1WhenEnabled.includes(provider)
		? isExternalIntegrationEnabled(integrations, provider)
		: isExternalIntegrationLive(integrations, provider);
